import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import complementaryRoadListAction from './complementaryRoadList.action.json' with { type: 'json' }
import { complementaryRoadObject } from '../complementaryRoadObject'

export const complementaryRoadExpression = expression(complementaryRoadObject.shape)

const complementaryRoadListDefinition = defineAction({
  ...complementaryRoadListAction,
  input: z.object({
    filter: complementaryRoadExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      code: 'Código',
      name: 'Nome',
      collectionMethod: 'Método de coleta',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(complementaryRoadObject),
    count: z.number(),
  }),
})

export default complementaryRoadListDefinition
